export const EVENTS = {
  REGISTRATION: {
    OPEN: 'registration.open',
    REGISTER: 'registration.REGISTER'
  },
  PAYMENT: {
    OPEN: 'payment.open',
    SUCCESS: 'payment.success',
    ERROR: 'payment.error'
  },
  QUOTE: {
    OPEN: 'QUOTE_REQUEST_OPEN'
  }
};
